/* eslint-disable react/jsx-key */
import {
  LoadingOutlined,
  ReloadOutlined,
  DownCircleOutlined,
  UpCircleOutlined,
  HighlightOutlined,
} from "@ant-design/icons";
import { useGlobalContext } from "../../../context/globalContext";
import { FONT_TEMPLATE } from "../../../data/captions";
import { generateCaptions } from "../../../shared/utils/VideoGeneration/audioGeneration";
import { Button, Col, Row, Switch, message, Alert, Tooltip } from "antd";
import React, { useEffect, useState, useCallback, useRef } from "react";
import "./captionsPanel.less";
import FontPickerRow from "./rows/fontPickerRow";
import ChooseFontTemplatesRow from "./rows/fontStyleRow";
import PositionSliderRow from "./rows/positionSliderRow";
import WordSlider from "./rows/wordSliderRow";
import { generateSubtitles } from "../../../shared/utils/captions";
import EditCaptions from "./rows/captionEditRow";
import { SectionTab } from "polotno/side-panel";
import { Message01Icon } from "@src/features/polotno/component/hugeIcons/hugeIcons";

interface CaptionsPanelProps {
  store: any;
}

export const CaptionsPanel: React.FC<CaptionsPanelProps> = React.memo(
  ({ store }: CaptionsPanelProps) => {
    const {
      ScriptDetails: [, setScriptDetails],
      RightSideBar: [activeComponent, setActiveComponent],
      UserDetail: [userDetail, setUserDetail],
      ActiveSidePanel: [activeSidePanel, setActiveSidePanel],
    } = useGlobalContext();
    useEffect(()=>{
      setActiveSidePanel(store.openedSidePanel)
    },[])
    const [showAdvanced, setShowAdvanced] = useState(false);
    const [showColorSetting, setShowColorSetting] = useState(false);
    const [captionsActiveIndex, setCaptionsActiveIndex] = useState<
      number | null
    >(null);
    const [selectedFont, setSelectedFont] = useState(
      store.pages[0].custom?.template?.font
        ? store.pages[0].custom?.template.font
        : FONT_TEMPLATE[0].font
    );
    const [wordsPerLine, setWordsPerLine] = useState(
      store.pages[0].custom?.template
        ? store.pages[0].custom?.template.wordsPerLine
        : FONT_TEMPLATE[0].wordsPerLine
    );

    const [yAxisPosition, setYAxisPosition] = useState(
      store.height - store.height * 0.2
    );
    const [fontTemplate, setFontTemplate] = useState<any>(
      store.pages[0].custom?.template
        ? store.pages[0].custom?.template
        : { ...FONT_TEMPLATE[0], position: store.height - store.height * 0.2 }
    );
    const [fontSize, setFontSize] = useState(
      store.pages[0].custom?.template
        ? store.pages[0].custom?.template.fontSize
        : FONT_TEMPLATE[0].fontSize
    );
    const [showSubtitles, setShowSubtitles] = useState<boolean>(true);

    const [showTryLaterMessage, setShowTryLaterMessage] = useState(false);
    const [regenrateButtonIcon, setRegenrateButtonIcon] = useState(false);
    
    // Add refs for debouncing color changes
    const colorUpdateTimeoutRef = useRef<NodeJS.Timeout | null>(null);
    const pendingFontTemplateRef = useRef<any>(null);

    const handleIconClick = (index: number) => {
      setCaptionsActiveIndex(index);
    };

    useEffect(() => {
      store.pages.map((page: any) => {
        if (!page?.custom?.captions || !(page?.custom?.captions?.length > 0)) {
          setShowTryLaterMessage(true);
        } else {
          if (!page?.custom)
            page.set({
              custom: { ...page.custom, template: FONT_TEMPLATE[0] },
            });
          if (!page?.custom?.template)
            page.set({
              custom: { ...page.custom, template: FONT_TEMPLATE[0] },
            });
        }
      });
      if (showSubtitles === true) {
        setScriptDetails((prevScript: { data: any }) => {
          const updatedScript = { ...prevScript };

          return { ...updatedScript, showSubtitles: true };
        });
        store.pages.map((page: any) => {
          const elementID = "captionText" + page.id;
          page.set({ custom: { ...page.custom, showSubtitles: true } });
          if (store.getElementById(elementID)) {
            store.getElementById(elementID).set({
              opacity: 1,
              backgroundEnabled: true,
            });
          }
        });
      }
    }, []);

    useEffect(() => {
      if (store.pages[0].cutom?.template?.name !== fontTemplate.name) {
        generateSubtitles(
          undefined,
          undefined,
          undefined,
          store,
          wordsPerLine,
          fontTemplate,
          showSubtitles,
          yAxisPosition,
          setYAxisPosition,
          setScriptDetails
        );
        setFontSize(fontTemplate.fontSize);
        setWordsPerLine(fontTemplate.wordsPerLine);
        setSelectedFont(fontTemplate.font);
      }
    }, [fontTemplate]);

    async function regenerateSubtitles() {
      setRegenrateButtonIcon(true);
      let captionsResult;
      await Promise.all(
        store.pages.map(async (page: any, index: number) => {
          // const audioUrl = page?.custom?.sounds[0]?.url;
          const audioUrl =
            Array.isArray(page?.custom?.sounds) && page.custom.sounds.length > 0
              ? page.custom.sounds[0].url
              : undefined;
          if (!audioUrl) {
            message.info("Audio not found");
            return;
          }
          captionsResult = await generateCaptions(
            audioUrl,
            userDetail?.purpose?.language || ""
          );
          if (captionsResult) {
            store.pages[index].set({
              custom: {
                ...store.pages[index].custom,
                captions: [{ words: captionsResult?.data?.words }],
              },
            });
          }
        })
      );
      if (captionsResult) {
        generateSubtitles(
          undefined,
          undefined,
          undefined,
          store,
          wordsPerLine,
          fontTemplate,
          showSubtitles,
          yAxisPosition,
          setYAxisPosition,
          setScriptDetails
        );
        setShowTryLaterMessage(false);
      } else {
        message.error("Regeneration Failed");
        setRegenrateButtonIcon(false);
        setShowTryLaterMessage(true);
      }
    }

    const setFontTemplates = (name: any) => {
      const template = FONT_TEMPLATE.find((template) => template.name === name);
      setFontTemplate(template);
    };

    const updateSubtitleYAxis = (yAxisPosition: number) => {
      console.log(store.toJSON())
      store.pages.map((page: any) => {
        console.log(page)
        const elementID = "captionText" + page.id;
        setYAxisPosition(yAxisPosition);
        // console.log(elementID)
        // 
        if (store.getElementById(elementID)) {
          store.getElementById(elementID).set({
            y: yAxisPosition,
          });
        }
        page.set({
          custom: {
            ...page.custom,
            template: { ...page.custom.template, position: yAxisPosition },
          },
        });
      });

      setScriptDetails((prevScript: { template: any }) => {
        const updatedScript = { ...prevScript };

        let updatedTemplate = { ...prevScript.template };

        updatedTemplate = {
          ...updatedTemplate,
          position: yAxisPosition,
        };

        return { ...updatedScript, template: updatedTemplate };
      });
    };

    const updateFontSize = (fontSize: number) => {
      setFontSize(fontSize);
      generateSubtitles(
        selectedFont,
        wordsPerLine,
        fontSize,
        store,
        wordsPerLine,
        fontTemplate,
        showSubtitles,
        yAxisPosition,
        setYAxisPosition,
        setScriptDetails
      );
    };

    const updateWordsPerLine = (wordsPerLine: number) => {
      setWordsPerLine(wordsPerLine);
      generateSubtitles(
        selectedFont,
        wordsPerLine,
        fontSize,
        store,
        wordsPerLine,
        fontTemplate,
        showSubtitles,
        yAxisPosition,
        setYAxisPosition,
        setScriptDetails
      );
    };

    const updateFont = (font: string) => {
      setSelectedFont(font);
      generateSubtitles(
        font,
        wordsPerLine,
        fontSize,
        store,
        wordsPerLine,
        fontTemplate,
        showSubtitles,
        yAxisPosition,
        setYAxisPosition,
        setScriptDetails
      );
    };

    const handleShowSubtitles = async () => {
      if (showSubtitles) {
        await setScriptDetails((prevScript: { data: any }) => {
          const updatedScript = { ...prevScript };

          return { ...updatedScript, showSubtitles: false };
        });
        store.pages.map((page: any) => {
          const elementID = "captionText" + page.id;
          page.set({ custom: { ...page.custom, showSubtitles: false } });
          if (store.getElementById(elementID)) {
            store.getElementById(elementID).set({
              opacity: 0,
              backgroundEnabled: false,
            });
          }
        });
      } else {
        await setScriptDetails((prevScript: { data: any }) => {
          const updatedScript = { ...prevScript };

          return { ...updatedScript, showSubtitles: true };
        });
        store.pages.map((page: any) => {
          const elementID = "captionText" + page.id;
          page.set({ custom: { ...page.custom, showSubtitles: true } });
          if (store.getElementById(elementID)) {
            store.getElementById(elementID).set({
              opacity: 1,
              backgroundEnabled: true,
            });
          }
        });
      }
      setShowSubtitles(!showSubtitles);
    };

    // Create a debounced update function for expensive subtitle generation
    const applyFontTemplateChanges = useCallback(() => {
      if (!pendingFontTemplateRef.current) return;
      
      const templateToApply = pendingFontTemplateRef.current;
      pendingFontTemplateRef.current = null;
      
      generateSubtitles(
        selectedFont,
        wordsPerLine,
        fontSize,
        store,
        wordsPerLine,
        templateToApply,
        showSubtitles,
        yAxisPosition,
        setYAxisPosition,
        setScriptDetails
      );
    }, [selectedFont, wordsPerLine, fontSize, store, showSubtitles, yAxisPosition]);

    // Update the color visually immediately but debounce the expensive generation
    const updateFontTemplate = useCallback((colorKey: string, colorValue: string) => {
      // Immediately update the UI
      setFontTemplate((prevTemplate: any) => ({ ...prevTemplate, [colorKey]: colorValue }));
      
      // Store the pending changes
      pendingFontTemplateRef.current = { 
        ...fontTemplate, 
        [colorKey]: colorValue 
      };
      
      // Clear any existing timeout
      if (colorUpdateTimeoutRef.current) {
        clearTimeout(colorUpdateTimeoutRef.current);
      }
      
      // Set a new timeout
      colorUpdateTimeoutRef.current = setTimeout(() => {
        applyFontTemplateChanges();
        colorUpdateTimeoutRef.current = null;
      }, 100); // 100ms debounce time
    }, [fontTemplate, applyFontTemplateChanges]);

    const pickFontColor = (e: any) => {
      updateFontTemplate('fontColor', e.target.value);
    };
    
    const pickBackgroundColor = (e: any) => {
      updateFontTemplate('backgroundColor', e.target.value);
    };
    
    const pickHiglightFont = (e: any) => {
      updateFontTemplate('highlightTextStyleColor', e.target.value);
    };
    
    const pickHighlightBackgroundColor = (e: any) => {
      updateFontTemplate('highlightTextBackground', e.target.value);
    };

    const {
      ScriptDetails: [scriptDetails],
    } = useGlobalContext();

    const handleShowVoiceOver = () => {
      setShowAdvanced(!showAdvanced);
    };

    const handleColorSetting = () => {
      setShowColorSetting(!showColorSetting);
    };

    // Clean up any pending timeouts on unmount
    useEffect(() => {
      return () => {
        if (colorUpdateTimeoutRef.current) {
          clearTimeout(colorUpdateTimeoutRef.current);
        }
      };
    }, []);
    
    const baseStyle: React.CSSProperties = {
      height: '100%',
      overflow: 'auto',
      backgroundColor: 'var(--color-surface)',
    }
    
    return (
      <div className="captions-panel">
        {showTryLaterMessage ? (
          <div className="error-section">
            <Label>Something went wrong</Label>
            <Button
              icon={regenrateButtonIcon ? <LoadingOutlined /> : <ReloadOutlined />}
              onClick={regenerateSubtitles}
            >
              Generate Captions
            </Button>
          </div>
        ) : (
          <>
            <div className="header-section">
              <h3>Captions</h3>
              <Switch
                defaultChecked={showSubtitles}
                checked={showSubtitles}
                onChange={handleShowSubtitles}
              />
            </div>

            <div className="section-container">
              <Label>Font</Label>
              <FontPickerRow
                defaultFont={selectedFont}
                onFontChange={updateFont}
                fontSize={fontSize}
                onFontSizeChange={updateFontSize}
              />
            </div>

            <div className="section-container">
              <Label>Caption Style</Label>
              <ChooseFontTemplatesRow
                templates={FONT_TEMPLATE}
                onSelect={setFontTemplates}
              />
            </div>

            <div className="section-container">
              <div className="section-title" onClick={handleColorSetting}>
                {!showColorSetting ? <DownCircleOutlined /> : <UpCircleOutlined />}
                Color Settings
              </div>
              <div className={`color-settings ${showColorSetting ? 'visible' : ''}`}>
                <div className="color-row">
                  <Label>Font color</Label>
                  <input
                    type="color"
                    className="color-input"
                    value={fontTemplate.fontColor}
                    onChange={pickFontColor}
                  />
                </div>
                <div className="color-row">
                  <Label>Highlight Text color</Label>
                  <input
                    type="color"
                    className="color-input"
                    value={fontTemplate.highlightTextStyleColor}
                    onChange={pickHiglightFont}
                  />
                </div>
                <div className="color-row">
                  <Label>Background color</Label>
                  <input
                    type="color"
                    className="color-input"
                    value={fontTemplate.backgroundColor}
                    onChange={pickBackgroundColor}
                  />
                </div>
                <div className="color-row">
                  <Label>Highlight Background color</Label>
                  <input
                    type="color"
                    className="color-input"
                    value={fontTemplate.highlightTextBackground}
                    onChange={pickHighlightBackgroundColor}
                  />
                </div>
              </div>
            </div>

            <div className="section-container">
              <Tooltip title="Adjust the words per line for captions.">
                <Label>Words Per Line</Label>
              </Tooltip>
              <WordSlider
                wordsPerLine={wordsPerLine}
                onFinish={updateWordsPerLine}
              />
            </div>

            <div className="section-container">
              <Label>Position</Label>
              <PositionSliderRow
                yAxis={yAxisPosition}
                setYAxis={updateSubtitleYAxis}
                maxYAxis={store.height}
              />
            </div>

            <div className="section-container">
              <div className="section-title" onClick={handleShowVoiceOver}>
                {!showAdvanced ? <DownCircleOutlined /> : <UpCircleOutlined />}
                Advanced Settings
              </div>
              <div className={`advanced-settings ${showAdvanced ? 'visible' : ''}`}>
                <div className="alert-section">
                  <Alert
                    message={
                      <>
                        <span>Use this panel only for correcting caption misspellings. For changing the entire caption, please update in the{" "}</span>
                        <Button
                          type="link"
                          onClick={() => setActiveComponent("audio")}
                        >
                          Voice Overs section
                        </Button>
                      </>
                    }
                    type="warning"
                  />
                </div>
                <div className="caption-edit-list">
                  {scriptDetails.data.map((scene: any, index: number) => (
                    <EditCaptions
                      key={index}
                      store={store}
                      words={scene?.captions?.[0]?.words || []}
                      index={index}
                      isActive={captionsActiveIndex === index}
                      onIconClick={() => handleIconClick(index)}
                    />
                  ))}
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    );
  }
);

export const Label = ({ children }: { children: React.ReactNode }) => {
  return (
    <h3
      style={{
        color: "black",
        fontSize: "14px",
        fontWeight: 500,
        fontFamily: "DM Sans",
        letterSpacing: "normal",
        marginBottom: "10px",
      }}
    >
      {children}
    </h3>
  );
};

CaptionsPanel.displayName = "CaptionsPanel";

export const CustomCaptionPolotno = {
  name: "caption-panel",
  Tab: (props: any) => (
    <SectionTab name="Caption" {...props}>
      <Message01Icon className="sidebar-panel-tab-icon" />
    </SectionTab>
  ),
  Panel: CaptionsPanel,
};
